import {css} from 'styled-components';

import {scToTwColour} from '../../theme';

export const BorderButtonCss = css`
  display: inline-block;
  margin-right: 0.5em;
  border: 2px solid ${scToTwColour('theme.colours.slate7')};
  background-color: transparent;
  border-radius: 0.3em;
  cursor: pointer;
  user-select: none;
  padding: 0.6rem;

  &:hover,
  &:focus {
    border-color: ${scToTwColour('theme.colours.slate8')};
  }

  ._icon {
    margin-right: 0.5em;
  }
`;

type ConditionalWrapperProps = {
  condition: boolean;
  wrapper: (children: React.ReactNode) => React.JSX.Element;
  children: React.ReactNode;
};
export const ConditionalWrapper = (props: ConditionalWrapperProps) => {
  return props.condition ? props.wrapper(props.children) : props.children;
};
